import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class LanguageAssessmentStatus extends AbstractModel {
  @autoserialize
  code: string;
}
